import { Bolt, Bookmark, BookOpenCheck, Calculator, ChartNoAxesGantt, ChevronLeft, ChevronRight, Clock, Flag, FlameKindling, Flashlight, Grid2x2, Grid3x3, List, Maximize, MessageCircleQuestion, Minimize, Minus, Newspaper, Pause, PauseCircle, PlayCircle, Plus, ShieldQuestion, ShieldQuestionIcon, X } from "lucide-react";
import React, { useState , useRef ,useEffect} from "react";

import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";


import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"

import ScientificCalculator from "../../../../UI/ScientificCalculator";
import { getAllQuizSectionsQuestionsOptionsInOne } from "../../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import QuestionOptionsStatic from "./QuestionOptionsStatic";
import MockTestStyles from "./MockTestStyles";
import MockTestBottom from "./MockTestBottom";
import MockTestPagenation from "./MockTestPagenation";
import MockTestPalette from "./MockTestPalette";
import MockTestTop from "./MockTestTop";
import MockTestQuestion from "./MockTestQuestion";
import MockTestSections from "./MockTestSections";
import MockTestQuestionPaper from "./MockTestQuestionPaper";
import MockTestStartBox from "./MockTestStartBox";
import MockTestPauseTest from "./MockTestPauseTest";
import MockTestReportQuestion from "./MockTestReportQuestion";
import MocktestHintPopUp from "./MocktestHintPopUp";
import MockTestInstructions from "./MockTestInstructions";
import MockTestSubmitInfoTable from "./MockTestSubmitInfoTable";

const MockTest = ({mockTestCard1Object}) =>{
   const [position, setPosition] = useState({ x: 0, y: 0 });
   const [sectionalPalletBtn, setSectionalPalletBtn] = useState({
  notVisited:0,
  visited:0,
  answered:0,
  markedAndNotAnswered:0,
  markedAndAnswered:0
  
});
   
   const history = useHistory();
     const dispatch = useDispatch();
     const [snackbarVisible, setSnackbarVisible] = useState(false);
     const [snackbarColor, setSnackbarColor] = useState("#958FDA");
     const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
   
     const [goNextPopUp, setGoNextPopUp] =useState(false);
      const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
             
    const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
      const showSnackbar = () => {
          setSnackbarVisible(true);
        };
        
         const hideSnackbar = () => {
          setSnackbarVisible(false);
        };
        const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        
        ;
        
       const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
      const appId = useSelector((state)=>state?.app?.app?.ID);
      const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
      
       const [loader , setLoader] =useState({status:false});
       const [animate, setAnimate] = useState(false);
      


         const [sectionsArr, setSectionsArr] = useState([]);
         const [questionsArr, setQuestionsArr] = useState([]);
         const [quizArr, setQuizArr] = useState([]);
       
        const [questionsArrDummy, setQestionsArrDummy] = useState([]);
        const [currentSection, setCurrentSection] = useState("All Sections");
            const [currentQuestionObject, setCurrentQuestionObject] = useState({});
            const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
              const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
        const [ visibility, setVisibility] = useState("public");
        const [ showLeftQueBar, setShowLeftQueBar] = useState(true);
        const [ queTypePopUp, setQueTypePopUp] = useState(false);
        const [ difficultyLevel, setDifficultyLevel] = useState("");
        const [ marks, setMarks] = useState(0);
        const [ negativeMarks, setNegativeMarks] = useState(0);
        const [ divideColumn, setDivideColumn] = useState("");
        const [ enableDisplayMarks, setEnableDisplayMarks] = useState(false);
       const [ enableQueHint, setEnableQueHint] = useState(false);
       const [ showHintPopUp, setShowHintPupUp] = useState(false);
       const [ responseTime, setResponseTime] = useState(1);
       const [ showQuestionOptions, setShowQuestionOptions] = useState(true);
           const [ testDesignValue, setTestDesignValue] = useState("");
     const [ palletDirection, setPalletDirection] = useState("right");
     const [ palletDirectionTemp, setPalletDirectionTemp] = useState("");
     const [ pagenationDirection, setPagenationDirection] = useState("bottom");
     const [fullScreen, setFullScreen] = useState(true);
     const [palletType, setPalletType] = useState("Grid");
      const [openCalculator, setOpenCalculator] = useState(false);
      const [showCalci, setShowCalci] = useState(true);
      const [testName, setTestName] = useState("Mock Test");
      const [overallTestTime, setOverallTestTime] = useState(60*60);
      const [lockSubmitButton, setLockSubmitButton] = useState("false");
      const [isRevealWithTimer, setIsRevealWithTimer] = useState("false");
      const [isRevealMode, setIsRevealMode] = useState("false");
      const [isRestrictQuestionNavigation, setIsRestrictQuestionNavigation] = useState("false");
      const [isLockSections, setIsLockSections] = useState("yes");
      const [allowUserNotes, setAllowUserNotes] = useState("true");
  const [loadSections, setLoadSections] = useState(true);
  const [buttonQuestionObject, setButtonQuestionObject] = useState("");
  const [sectionStatsAll ,setSectionStatsAll]= useState({});
   const [closeStartBoxPopUp, setCloseStartBoxPopUp] = useState(false);
   const [closePausePopUp, setClosePausePopUp] = useState(false);
   const [closeReportPopUp, setCloseReportPopUp] = useState(false);
 const [closeHintPopUp, setCloseHintPopUp] = useState(false);
 const [closeInstructionsPopUp, setCloseInstructionsPopUp] = useState(false);
 const [closeSubmitInfoPopUp, setCloseSubmitInfoPopUp] = useState(false);
 
       const [ questionPaperVisible, setQuestionPaperVisible] = useState(true);
  // response array  all data set here // when user loads test for first time ,
  // insert all ques (responses)// (iterate all response entry per questions Id In Backend)  , 
  // &  get back response array and set it . (response table=(appid + testid) for many users many attempts per test )
  const [responseArray, setResponseArray] = useState([
    { ID: 1, timer: 0 },
    { ID: 2, timer: 0 },
    { ID: 3, timer: 0 }
  ]);
   
       const [activeColorPickerValue,setActiveColorPickerValue]=useState(
        {color1:"rgba( 105, 95, 95, 0.1)",
        color2:"rgba( 105, 95, 95, 0.2)",
        color3:"rgba( 105, 95, 95, 0.3)",
        color4:"rgba( 105, 95, 95, 0.4)",
        color5:"rgba( 105, 95, 95, 0.5)",
        color6:"rgba( 105, 95, 95, 0.6)",
        color7:"rgba( 105, 95, 95, 0.7)",
        color8:"rgba( 105, 95, 95, 0.8)",
        color9:"rgba( 105, 95, 95, 0.9)",
        color10:"rgba( 105, 95, 95, 1)",
        alpha:1})
 useEffect(()=>{
      
        fireGetAllQuizSectionsQuestionsOptionsInOne();
      },[])
   
useEffect(()=>{
  setShowQuestionOptions(false);setTimeout(()=>{ setShowQuestionOptions(true);},10)
  
},[currentQuestionObject?.ID])
  const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
    
    </div>
  );
};
const fireGetAllQuizSectionsQuestionsOptionsInOne=()=>{
   setItemArrLoading([{},{},{},{},{},{}])
    setLoader({status:true});
    
      const apiData = dispatch(getAllQuizSectionsQuestionsOptionsInOne({testName:"",type:"question",
        postParent:6,userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        postId:6,menuOrder:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
            console.log(response)
            const updatedArr = response?.questions.map(q => ({
  ...q,
  timer: 0
}));
setResponseArray(updatedArr);
 
            setSectionsArr(response?.sections);
               setQestionsArrDummy(response?.questions)
            // setQuestionsArr(response?.questions);
            setQuestionsArr(getQuestionsFromOneSection(response?.questions,response?.sections?.length?response?.sections[0]?.secQuestions:[]));
          
          SetSectionPalletButtons();
            setCurrentSection(response?.sections?.length?response?.sections[0]:[])
            setCurrentQuestionObject(getQuestionsFromOneSection(response?.questions,response?.sections?.length?response?.sections[0]?.secQuestions:[])?.length?getQuestionsFromOneSection(response?.questions,response?.sections?.length?response?.sections[0]?.secQuestions:[])[0]:[])
         
          SetQuestionVisited(getQuestionsFromOneSection(response?.questions,response?.sections?.length?response?.sections[0]?.secQuestions:[])?.length?getQuestionsFromOneSection(response?.questions,response?.sections?.length?response?.sections[0]?.secQuestions:[])[0]:[],"visited");
         
            handleQuestionClick(getQuestionsFromOneSection(response?.questions,response?.sections?.length?response?.sections[0]?.secQuestions:[])?.length?getQuestionsFromOneSection(response?.questions,response?.sections?.length?response?.sections[0]?.secQuestions:[])[0]?.ID:"");
            setQuizArr(response?.quiz);
            // console.log(response)
          if(response?.quiz){
           
            setItemArrLoading([])
          setActiveColorPickerValue(response?.quiz?.testInterfaceColor?JSON.parse(response?.quiz?.testInterfaceColor)?.colorScheme?.colors:activeColorPickerValue)
       setTestDesignValue(response?.quiz?.testPalletOrPage)
     setPalletDirection(response?.quiz?.palletDirection)
     setPagenationDirection(response?.quiz?.pagenationDirection)
  setShowCalci(response?.quiz?.showCalci)
       setTestName(response?.quiz?.testName)
       setOverallTestTime(parseInt(response?.quiz?.overallTestTime)*60-1)
       setLockSubmitButton(response?.quiz?.lockSubmitButton)
       setIsRevealWithTimer(response?.quiz?.isRevealWithTimer)
       setIsRevealMode(response?.quiz?.isRevealMode)
       setIsRestrictQuestionNavigation(response?.quiz?.isRestrictQuestionNavigation)
       setIsLockSections(response?.quiz?.isLockSections)
          setResponseMessage(response?.message);  
          setAllowUserNotes(response?.quiz?.allowUserNotes)

        setSnackbarColor("rgba(144, 202, 249,1)");
      
        //  setItemArr( response?.questions?response?.questions:[])
      
       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }

useEffect(() => {
  const totals = {
    notVisited: 0,
    visited: 0,
    answered: 0,
    markedAndNotAnswered: 0,
    markedAndAnswered: 0
  };

  sectionsArr?.forEach(section => {
    let questions = [];

    try {
      questions = Array.isArray(section?.secQuestions)
        ? section?.secQuestions
        : JSON.parse(section?.secQuestions || "[]");
    } catch (e) {
      console.error("Invalid secQuestions in section", section?.sectionName);
    }

    totals.notVisited += questions.filter(q => !q?.visited && !q?.answered && !q?.marked)?.length;
    totals.visited += questions.filter(q => q?.visited && !q?.answered && !q?.marked)?.length;
    totals.answered += questions.filter(q => q?.visited && q?.answered && !q?.marked)?.length;
    totals.markedAndNotAnswered += questions.filter(q => q?.visited && !q?.answered && q?.marked)?.length;
    totals.markedAndAnswered += questions.filter(q => q?.visited && q?.answered && q?.marked)?.length;
    totals.timeSpent=sectionStatsAll?.timeSpent
  });

  // ✅ Update state once
  setSectionStatsAll(totals);
}, [sectionsArr]); 
const ButtonQuestionInfo = () => {
 

  useEffect(() => {
    const handleMouseMoveQuestionInfo = (event) => {
      setPosition({ x: event.clientX, y: event.clientY });
    };

    window.addEventListener('mousemove', handleMouseMoveQuestionInfo);

    return () => {
      window.removeEventListener('mousemove', handleMouseMoveQuestionInfo);
    };
  }, []);

  return (<div>
    <div
      className={`buttonQuestionInfoCursor ${buttonQuestionObject?.que?.ID ? 'hovered' : ''}`}
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
      }}
      

    > </div>{buttonQuestionObject?.que?.ID?<div  className={`${buttonQuestionObject?.dir=="right"?"buttonQuestionInfoCursor-text-right":buttonQuestionObject?.dir=="left"?"buttonQuestionInfoCursor-text-left"
      :buttonQuestionObject?.dir=="top"?"buttonQuestionInfoCursor-text-top":buttonQuestionObject?.dir=="bottom"?"buttonQuestionInfoCursor-text-bottom":""}`} style={buttonQuestionObject?.dir=="right"?
    {left: `${position.x+120}px`,
    top: `${position.y-10}px`,
  padding:"10px 19px", textAlign:"center",color:"#222",background:`${mockTestCard1Object?.buttonInfoInner?.bgColor?.color}`,
border:` ${mockTestCard1Object?.buttonInfoInner?.border?.borderWidth?.value+mockTestCard1Object?.buttonInfoInner?.border?.borderWidth?.resolution} ${mockTestCard1Object?.buttonInfoInner?.border?.borderType}  ${mockTestCard1Object?.buttonInfoInner?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topLeft?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topRight?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomRight?.resolution}`,
}:
  buttonQuestionObject?.dir=="left"?
  {left: `${position.x-120}px`,
    top: `${position.y-10}px`,
  padding:"10px 19px", textAlign:"center",color:"#222",background:`${mockTestCard1Object?.buttonInfoInner?.bgColor?.color}`,
border:` ${mockTestCard1Object?.buttonInfoInner?.border?.borderWidth?.value+mockTestCard1Object?.buttonInfoInner?.border?.borderWidth?.resolution} ${mockTestCard1Object?.buttonInfoInner?.border?.borderType}  ${mockTestCard1Object?.buttonInfoInner?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topLeft?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topRight?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomRight?.resolution}`,
}:buttonQuestionObject?.dir=="top"?
  {left: `${position.x+70}px`,
    top: `${position.y+130}px`,
  padding:"10px 19px", textAlign:"center",color:"#222",background:`${mockTestCard1Object?.buttonInfoInner?.bgColor?.color}`,
border:` ${mockTestCard1Object?.buttonInfoInner?.border?.borderWidth?.value+mockTestCard1Object?.buttonInfoInner?.border?.borderWidth?.resolution} ${mockTestCard1Object?.buttonInfoInner?.border?.borderType}  ${mockTestCard1Object?.buttonInfoInner?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topLeft?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topRight?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomRight?.resolution}`,
}:buttonQuestionObject?.dir=="bottom"?
  {left: `${position.x+70}px`,
    top: `${position.y-130}px`,
  padding:"5px 19px", textAlign:"center",color:"#222",background:`${mockTestCard1Object?.buttonInfoInner?.bgColor?.color}`,
border:` ${mockTestCard1Object?.buttonInfoInner?.border?.borderWidth?.value+mockTestCard1Object?.buttonInfoInner?.border?.borderWidth?.resolution} ${mockTestCard1Object?.buttonInfoInner?.border?.borderType}  ${mockTestCard1Object?.buttonInfoInner?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topLeft?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topRight?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.buttonInfoInner?.borderRadius?.bottomRight?.resolution}`,
}:""}>
   
    <div className=" ellipsisTitleQuizTwoRows mockTestTitleFont" style={{width:"150px",height:"28px",
    borderRadius:"5px",fontWeight:"999",paddingLeft:"8px",fontWeight:"500",fontSize:"14px",textDecoration:"uppercase",
    color:`${mockTestCard1Object?.questionName?.textColor?.color}`,display:"flex",
    justifyContent:"left",alignItems:"center",
    background:`${mockTestCard1Object?.questionName?.bgColor?.color}`,
border:` ${mockTestCard1Object?.questionName?.border?.borderWidth?.value+mockTestCard1Object?.questionName?.border?.borderWidth?.resolution} ${mockTestCard1Object?.questionName?.border?.borderType}  ${mockTestCard1Object?.questionName?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.questionName?.borderRadius?.topLeft?.value}${mockTestCard1Object?.questionName?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.questionName?.borderRadius?.topRight?.value}${mockTestCard1Object?.questionName?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.questionName?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.questionName?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.questionName?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.questionName?.borderRadius?.bottomRight?.resolution}`,
}}>
      
     Que: {buttonQuestionObject?.que?.queName}</div>
       <div style={{display:"flex",justifyContent:"space-between",padding:"0px",gap:"5px",marginTop:"10px",fontSize:"12px"}}>
 <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",gap:"5px",padding:"5px 5px",background:`${mockTestCard1Object?.queType?.bgColor?.color}`,
border:` ${mockTestCard1Object?.queType?.border?.borderWidth?.value+mockTestCard1Object?.queType?.border?.borderWidth?.resolution} ${mockTestCard1Object?.queType?.border?.borderType}  ${mockTestCard1Object?.queType?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.queType?.borderRadius?.topLeft?.value}${mockTestCard1Object?.queType?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.queType?.borderRadius?.topRight?.value}${mockTestCard1Object?.queType?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.queType?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.queType?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.queType?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.queType?.borderRadius?.bottomRight?.resolution}`,
}}>
  <div><BookOpenCheck    color={mockTestCard1Object?.queType?.iconColor?.color} size={15}/></div>
        <div className="mockTestTagsFont"> {buttonQuestionObject?.que?.queType}</div>  
          </div>   
          
          <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",gap:"5px",padding:"5px 5px"
            ,background:`${mockTestCard1Object?.difficultyLevel?.bgColor?.color}`,
border:` ${mockTestCard1Object?.difficultyLevel?.border?.borderWidth?.value+mockTestCard1Object?.difficultyLevel?.border?.borderWidth?.resolution} ${mockTestCard1Object?.difficultyLevel?.border?.borderType}  ${mockTestCard1Object?.difficultyLevel?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.difficultyLevel?.borderRadius?.topLeft?.value}${mockTestCard1Object?.difficultyLevel?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.difficultyLevel?.borderRadius?.topRight?.value}${mockTestCard1Object?.difficultyLevel?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.difficultyLevel?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.difficultyLevel?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.difficultyLevel?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.difficultyLevel?.borderRadius?.bottomRight?.resolution}`,
}}>
  <div><MessageCircleQuestion    color={mockTestCard1Object?.difficultyLevel?.iconColor?.color} size={15}/></div>
        <div  className="mockTestTagsFont"> {buttonQuestionObject?.que?.difficultyLevel}</div>  
          </div>
          
          </div>
            <div className="" style={{ display:"flex",borderRadius:"5px",justifyContent:"space-between" ,}}> 
          <div className="" style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",margin:"5px",marginLeft:"0px",gap:"5px"
          ,background:`${mockTestCard1Object?.questionTimer?.bgColor?.color}`,
border:` ${mockTestCard1Object?.questionTimer?.border?.borderWidth?.value+mockTestCard1Object?.questionTimer?.border?.borderWidth?.resolution} ${mockTestCard1Object?.questionTimer?.border?.borderType}  ${mockTestCard1Object?.questionTimer?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.questionTimer?.borderRadius?.topLeft?.value}${mockTestCard1Object?.questionTimer?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.questionTimer?.borderRadius?.topRight?.value}${mockTestCard1Object?.questionTimer?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.questionTimer?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.questionTimer?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.questionTimer?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.questionTimer?.borderRadius?.bottomRight?.resolution}`,
fontSize:"12px"}}> <Clock style={{position:"relative"}} 
  color={mockTestCard1Object?.questionTimer?.iconColor?.color} size={15}/> {formatTimeQue(getTimerByActiveID(buttonQuestionObject?.que?.ID))}</div>
           {buttonQuestionObject?.que?.enableDisplayMarks=="true"?<div style={{display:"flex",justifyContent:"space-between",gap:"10px",padding:"5px"}}>
 <div className="mockTestTagsFont" style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",background:`${mockTestCard1Object?.plusMarks?.bgColor?.color}`,
border:` ${mockTestCard1Object?.plusMarks?.border?.borderWidth?.value+mockTestCard1Object?.plusMarks?.border?.borderWidth?.resolution} ${mockTestCard1Object?.plusMarks?.border?.borderType}  ${mockTestCard1Object?.plusMarks?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.plusMarks?.borderRadius?.topLeft?.value}${mockTestCard1Object?.plusMarks?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.plusMarks?.borderRadius?.topRight?.value}${mockTestCard1Object?.plusMarks?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.plusMarks?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.plusMarks?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.plusMarks?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.plusMarks?.borderRadius?.bottomRight?.resolution}`,

  fontSize:"12px"
 }}>

       <Plus style={{position:"relative"}}   color={mockTestCard1Object?.plusMarks?.iconColor?.color} size={15}/>
          {buttonQuestionObject?.que?.marks}
          </div> <div  className="mockTestTagsFont" style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",background:`${mockTestCard1Object?.negativeMarks?.bgColor?.color}`,
border:` ${mockTestCard1Object?.negativeMarks?.border?.borderWidth?.value+mockTestCard1Object?.negativeMarks?.border?.borderWidth?.resolution} ${mockTestCard1Object?.negativeMarks?.border?.borderType}  ${mockTestCard1Object?.negativeMarks?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.negativeMarks?.borderRadius?.topLeft?.value}${mockTestCard1Object?.negativeMarks?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.negativeMarks?.borderRadius?.topRight?.value}${mockTestCard1Object?.negativeMarks?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.negativeMarks?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.negativeMarks?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.negativeMarks?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.negativeMarks?.borderRadius?.bottomRight?.resolution}`,
fontSize:"12px"
          }}>
 <Minus style={{position:"relative"}}   color={mockTestCard1Object?.negativeMarks?.iconColor?.color} size={15}/>
            {buttonQuestionObject?.que?.negativeMarks}
          </div>   </div>:""}
     </div>

     <div style={{padding:"5px"}} >
      {buttonQuestionObject?.que?.options?.map((option,index)=>(<>
       <div  style={{margin:"5px" }}>
      <div className=" ellipsisTitleQuiz" style={{ display:"flex",borderRadius:"5px",justifyContent:"left" ,background:"#fff",width:"140px",padding:"5px",margin:"5px",
    borderRadius:"5px",fontWeight:"999",fontWeight:"500",color:"#888",fontSize:"14px"}}>
     {index+1}: {option?.optionText}</div></div></>))}
      </div>
    </div>:""}
    
  </div>);
};









    
          const divRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const enterFullscreen = () => {
    const el = divRef.current;

    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
    } else if (el.msRequestFullscreen) {
      el.msRequestFullscreen();
    }

    setIsFullscreen(true);
  };

  const exitFullscreen = () => {
    if (document?.exitFullscreen) {
      document?.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document?.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document?.msExitFullscreen();
    }

    setIsFullscreen(false);
  };

  // Handle when the user exits fullscreen manually (Esc key, etc.)
  React.useEffect(() => {
    const handleFullscreenChange = () => {
      const fsElement =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement;

      setIsFullscreen(!!fsElement);
      // reset fullscreen button on esc btn press
      setFullScreen(!fsElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, []);

 const [isRunning, setIsRunning] = useState(true);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (isRunning && overallTestTime > 0) {
      intervalRef.current = setInterval(() => {
        setOverallTestTime(prev => prev - 1);
      }, 1000);
    }

    return () => clearInterval(intervalRef.current);
  }, [isRunning]);


const getQuestionsFromOneSection = (questionsArrAll, secQuestionsIDArr) => { 
  let secQuestions = [];

  try {
    secQuestions = Array.isArray(secQuestionsIDArr)
      ? secQuestionsIDArr
      : JSON.parse(secQuestionsIDArr || '[]');
  } catch (e) {
    console.warn("Invalid JSON in secQuestions", e);
    return [];
  }

  // Map of all available questions by ID for fast lookup
  const questionMap = new Map();
  questionsArrAll?.forEach(q => questionMap.set(q?.ID, q));

  // Preserve the order from secQuestions
  return secQuestions
    .map(q => questionMap.get(q?.ID))
    .filter(Boolean); // remove undefined if any ID is not found
};
const findSectionNameByQuestionId = ( questionId) => {
  for (const section of sectionsArr) {
    try {
      const secQuestions = section?.secQuestions
        ? JSON.parse(section?.secQuestions)
        : [];

      const found = secQuestions.some(q => q?.ID === questionId);
      if (found) {
        return section?.sectionName; // return the section name where the question is found
      }
    } catch (error) {
      console.error("Invalid JSON in secQuestions for section:", section?.ID);
    }
  }

  return null; // not found
};

const findSectionIDBysection = ( section) => {
 

  return currentSection?.ID==section?.ID?"true":"false"; // true
};
const getArrayLength =(section)=>{
  return section?.secQuestions?JSON.parse(section?.secQuestions)?.length:0
}
  useEffect(() => {
    if (overallTestTime <= 0) {
      clearInterval(intervalRef.current);
      setIsRunning(false);
    }
  }, [overallTestTime]);

  const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return `${hrs}:${mins}:${secs}`;
  };

  const handleStartPause = () => {
    setIsRunning(prev => !prev);
  };

  const formatTimeQue = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return hours?[
    hours.toString().padStart(2, '0'),
    minutes.toString().padStart(2, '0'),
    seconds.toString().padStart(2, '0'),
  ].join(':'):[
   
    minutes.toString().padStart(2, '0'),
    seconds.toString().padStart(2, '0'),
  ].join(':');
};


// question timer

const [activeID, setActiveID] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (isRunning && activeID !== null) {
        setResponseArray(prev =>
          prev.map(q =>
            q.ID === activeID ? { ...q, timer: q.timer + 1 } : q
          )
        );
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [isRunning, activeID]);


useEffect(() => {
  setSectionsArr(prev =>
    prev.map(section => {
      let secQuestions = [];

      try {
        secQuestions = Array.isArray(section?.secQuestions)
          ? section.secQuestions
          : JSON.parse(section?.secQuestions || "[]");
      } catch (e) {
        console.warn("Invalid JSON in secQuestions", e);
      }

      // IDs in section
      const secIDs = new Set(secQuestions.map(q => q?.ID?.toString()));

      // Sum timer for questions in this section
      const sectionTime = responseArray
        .filter(q => secIDs.has(q?.ID?.toString()))
        .reduce((sum, q) => sum + (q.timer || 0), 0);
       
      return {
        ...section,
        sectionStats: {
          ...section.sectionStats,
          timeSpent: sectionTime
        }
      };
    })
  );

  // Also compute overall total time
  const totalTime = responseArray.reduce(
    (sum, q) => sum + (q.timer || 0),
    0
  );

  setSectionStatsAll({...sectionStatsAll, timeSpent: totalTime})
 
}, [responseArray]);




    const SetSectionPalletButtons=()=>{
  setQuestionPaperVisible(true);
    
setSectionsArr(prev =>
  prev.map(section => {
    const questions = section?.secQuestions?JSON.parse(section?.secQuestions):[];

    const totalSectionalNotVisited = questions?.filter(q =>
      q?.visited !== "visited" &&
      q?.answered !== "answered" &&
      q?.marked !== "marked"
    )?.length;

    const totalSectionalVisited = questions?.filter(q =>
      q?.visited === "visited" &&
      q?.answered !== "answered" &&
      q?.marked !== "marked"
    )?.length;

    const totalSectionalAnswered = questions?.filter(q =>
      q?.visited === "visited" &&
      q?.answered === "answered" &&
      q?.marked !== "marked"
    )?.length;

    const totalSectionalMarkedAndNotAnswered = questions?.filter(q =>
      q?.visited === "visited" &&
      q?.answered !== "answered" &&
      q?.marked === "marked"
    )?.length;

    const totalSectionalMarkedAndAnswered = questions?.filter(q =>
      q?.visited === "visited" &&
      q?.answered === "answered" &&
      q?.marked === "marked"
    )?.length;
    // console.log(prev)
    return {
      ...section,
      sectionStats: {
        notVisited: totalSectionalNotVisited,
        visited: totalSectionalVisited,
        answered: totalSectionalAnswered,
        markedAndNotAnswered: totalSectionalMarkedAndNotAnswered,
        markedAndAnswered: totalSectionalMarkedAndAnswered
      }
    };
   
  })
);


  }


  const calculateSectionStats = (questions) => {
  const notVisited = questions.filter(q =>
    q.visited !== "visited" &&
    q.answered !== "answered" &&
    q.marked !== "marked"
  )?.length;

  const visited = questions.filter(q =>
    q.visited === "visited" &&
    q.answered !== "answered" &&
    q.marked !== "marked"
  )?.length;

  const answered = questions.filter(q =>
    q.visited === "visited" &&
    q.answered === "answered" &&
    q.marked !== "marked"
  )?.length;

  const markedAndNotAnswered = questions.filter(q =>
    q.visited === "visited" &&
    q.answered !== "answered" &&
    q.marked === "marked"
  )?.length;

  const markedAndAnswered = questions.filter(q =>
    q.visited === "visited" &&
    q.answered === "answered" &&
    q.marked === "marked"
  )?.length;
  
  return {
    notVisited,
    visited,
    answered,
    markedAndNotAnswered,
    markedAndAnswered
  };
};
const parseQuestions = (secQuestions) => {
  if (typeof secQuestions === 'string') {
    try {
      return JSON.parse(secQuestions);
    } catch (e) {
      console.error("Invalid JSON in secQuestions:", e);
      return [];
    }
  }
  return secQuestions || [];
};
const SetQuestionVisited = (questionObject, status) => {
    setQuestionPaperVisible(true);
  setSectionsArr(prev =>
    prev.map(section => {
     let questions = parseQuestions(section.secQuestions);

      const updatedQuestions = questions.map(q =>
        q.ID === questionObject?.ID ? { ...q, visited: status } : q
      );

      const sectionStats = calculateSectionStats(updatedQuestions);

      return {
        ...section,
        secQuestions: updatedQuestions,
        sectionStats
      };
    })
  );

  // api request 

};

const SetQuestionAnswered = (questionObject, status) => {
    setQuestionPaperVisible(true);
  setSectionsArr(prev =>
    prev.map(section => {
    let questions = parseQuestions(section.secQuestions);

      const updatedQuestions = questions.map(q =>
        q.ID === questionObject?.ID ? { ...q, answered: status } : q
      );

      const sectionStats = calculateSectionStats(updatedQuestions);

      return {
        ...section,
        secQuestions: updatedQuestions,
        sectionStats
      };
    })


  );

   // api request 
};


const SetQuestionClearResponse = (questionObject, status) => {
    setQuestionPaperVisible(true);
  setSectionsArr(prev =>
    prev.map(section => {
    let questions = parseQuestions(section.secQuestions);

      const updatedQuestions = questions.map(q =>
        q.ID === questionObject?.ID ? { ...q, visited: "visited", answered: status, marked: status } : q
      );

      const sectionStats = calculateSectionStats(updatedQuestions);

      return {
        ...section,
        secQuestions: updatedQuestions,
        sectionStats
      };
    })


  );

   // api request 
};


const SetQuestionMarked = (questionObject, status) => {
    setQuestionPaperVisible(true);
  setSectionsArr(prev =>
    prev.map(section => {
     let questions = parseQuestions(section?.secQuestions);
      const updatedQuestions = questions.map(q =>
        q.ID === questionObject?.ID ? { ...q, marked: status } : q
      );

      const sectionStats = calculateSectionStats(updatedQuestions);

      return {
        ...section,
        secQuestions: updatedQuestions,
        sectionStats
      };
    })
  );

   // api request 
};
  const handleQuestionClick = (id) => {
    setActiveID(id);
  };

const getTimerByActiveID = ( activeID) => {
  const question = responseArray.find(q => q.ID === activeID);
  return question ? question.timer : 0;
};

const goTONextQuestion=()=>{
    setQuestionPaperVisible(true);
if(currentQuestionIndex<questionsArr?.length-1) {
   setCurrentQuestionObject(questionsArr[currentQuestionIndex+1]);
   setCurrentQuestionIndex(currentQuestionIndex+1)
     handleQuestionClick(questionsArr[currentQuestionIndex+1]?.ID);
     SetQuestionVisited(questionsArr[currentQuestionIndex+1],"visited");

}
else if(currentSectionIndex<sectionsArr?.length-1){
 setQuestionsArr(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex+1]?.secQuestions));
setCurrentSection(sectionsArr[currentSectionIndex+1]);
             setCurrentSectionIndex(currentSectionIndex+1);setCurrentQuestionIndex(0);
               setCurrentQuestionObject(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex+1]?.secQuestions)?.length?getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex+1]?.secQuestions)[0]:[])
               
               setLoadSections(false); setTimeout(()=>{ setLoadSections(true); },0);
                handleQuestionClick(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex+1]?.secQuestions)?.length?getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex+1]?.secQuestions)[0]?.ID:"");
          SetQuestionVisited(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex+1]?.secQuestions)?.length?getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex+1]?.secQuestions)[0]:[],"visited");
}
 
} 



const goTOPreviousQuestion=()=>{
    setQuestionPaperVisible(true);
if(currentQuestionIndex>0) {
   setCurrentQuestionObject(questionsArr[currentQuestionIndex-1]);
   setCurrentQuestionIndex(currentQuestionIndex-1)
   handleQuestionClick(questionsArr[currentQuestionIndex-1]?.ID);
   SetQuestionVisited(questionsArr[currentQuestionIndex-1],"visited");
}
else if(currentSectionIndex>0){
  
   setQuestionsArr(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions));
setCurrentSection(sectionsArr[currentSectionIndex-1]);
             setCurrentSectionIndex(currentSectionIndex-1);
               setCurrentQuestionObject(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)?.length?getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)[getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)?.length-1]:[])
              setCurrentQuestionIndex(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)?.length-1);
              // alert(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)?.length)
               setLoadSections(false); setTimeout(()=>{ setLoadSections(true); },0);
                handleQuestionClick(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)?.length?getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)[getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)?.length-1]?.ID:"");
          SetQuestionVisited(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)?.length?getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)[getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)?.length-1]:[],"visited");


              }
 
} 
return(<>
<ButtonQuestionInfo />
 <div  ref={divRef}  className="" style={{borderRadius: '0px',border:"0px solid #fff",background:"#fff"}}>
                 {/* <div style={{background:"rgba(105, 95, 95,0.1)",width:"30px",height:"30px",borderRadius:"50%",position:"absolute",right:"10px",top:"0px",
                     alignContent:"center",textAlign:"center",padding:"5px",margin:"10px",cursor:"pointer"}} onClick={()=>setShowTestPreview()} ><X size={22}  color="rgb(105, 95, 95)"/></div>  */}
 
 {closeReportPopUp?<MockTestReportQuestion
 
 mockTestCard1Object={mockTestCard1Object}

 setCloseReportPopUp={(v)=>{setCloseReportPopUp(v)}}
   handleReport={()=>{setCloseReportPopUp(false) }}
 />:""}
 {closeHintPopUp?<MocktestHintPopUp
 
 mockTestCard1Object={mockTestCard1Object}

 setCloseHintPopUp={(v)=>{setCloseHintPopUp(v)}}
   handleHint={()=>{setCloseHintPopUp(false) }}
 />:""}

 {closePausePopUp?<MockTestPauseTest 
 overallTestTime={overallTestTime}
 mockTestCard1Object={mockTestCard1Object}
  isRunning={isRunning}
 setClosePausePopUp={(v)=>{setClosePausePopUp(v)}}
   handleStartPause={()=>{handleStartPause() ;setClosePausePopUp(false) }}
 />:""}

 {closeStartBoxPopUp?<MockTestStartBox  setCloseStartBoxPopUp={(v)=>{setCloseStartBoxPopUp(v)}}
 
  setCloseInstructionsPopUp={(v)=>{setCloseInstructionsPopUp(v)}}  />:""}
  {closeInstructionsPopUp?<MockTestInstructions  setCloseInstructionsPopUp={(v)=>{setCloseInstructionsPopUp(v)}}
   />:""}
{closeSubmitInfoPopUp?<MockTestSubmitInfoTable  setCloseSubmitInfoPopUp={(v)=>{setCloseSubmitInfoPopUp(v)}}
  />:""}
  {closeInstructionsPopUp?<MockTestInstructions  setCloseInstructionsPopUp={(v)=>{setCloseInstructionsPopUp(v)}}
   />:""}

 <MockTestTop setCloseStartBoxPopUp={(v)=>{setCloseStartBoxPopUp(v)}}
 testName={testName}
 fullScreen={fullScreen}
 isRunning={isRunning}
 handleStartPause={()=>{ setClosePausePopUp(true)}}
 overallTestTime={overallTestTime}
 mockTestCard1Object={mockTestCard1Object}
 setQuestionPaperVisible={(v)=>{setQuestionPaperVisible(v)}}
 setFullScreen={(v)=>{setFullScreen(v)}}
 enterFullscreen={()=>{enterFullscreen()}}
 exitFullscreen={()=>{exitFullscreen()}}  />



 <div style={{display:"grid", gridTemplateColumns: testDesignValue=="pallet"&&palletDirection=="left"?"25% 75% ":testDesignValue=="pallet"&&palletDirection=="left"?"75% 25%":"100%" ,}} >
  
<div>


     { testDesignValue=="pallet"&&palletDirection=="left"?<div></div>:""} <div style={{position:"fixed",left: testDesignValue=="pallet"&&palletDirection=="left"?"25%":"0px",right:testDesignValue=="pallet"&&palletDirection=="right"?"25%":"0px" ,
    background:`${mockTestCard1Object?.middleOuterCard?.bgColor?.color}`,
border:` ${mockTestCard1Object?.middleOuterCard?.border?.borderWidth?.value+mockTestCard1Object?.middleOuterCard?.border?.borderWidth?.resolution} ${mockTestCard1Object?.middleOuterCard?.border?.borderType}  ${mockTestCard1Object?.middleOuterCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.middleOuterCard?.borderRadius?.topLeft?.value}${mockTestCard1Object?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.middleOuterCard?.borderRadius?.topRight?.value}${mockTestCard1Object?.middleOuterCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.middleOuterCard?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.middleOuterCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.middleOuterCard?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.middleOuterCard?.borderRadius?.bottomRight?.resolution}`,
 
        top:testDesignValue=="pagenation"&&pagenationDirection==="top"?"110px":"60px",bottom:testDesignValue=="pagenation"&&pagenationDirection==="bottom"?"130px":"60px",overflowY:"auto",overflowX:"hidden"}}>
     
      {questionPaperVisible?
      <div style={{padding:"5px",}}>
       <MockTestSections 
       setCloseReportPopUp={(v)=>{setCloseReportPopUp(v)}}
       responseArray={responseArray}
        currentSection={currentSection}
    showCalci={showCalci}
        sectionsArr={sectionsArr}
       currentQuestionObject={currentQuestionObject}
       activeID={activeID}
       sectionStatsAll={sectionStatsAll}
       setOpenCalculator={(v)=>{setOpenCalculator(v)}}
       mockTestCard1Object={mockTestCard1Object}
       setQuestionsArr={(v)=>{setQuestionsArr(v)}}
       questionsArrDummy={questionsArrDummy}
    setCurrentSection={(v)=>{setCurrentSection(v)}}
    getQuestionsFromOneSection={(v1,v2)=>{getQuestionsFromOneSection(v1,v2)}}
    setCurrentSectionIndex={(v)=>{setCurrentSectionIndex(v)}}
    setCurrentQuestionIndex={(v)=>{setCurrentQuestionIndex(v)}}
    setCurrentQuestionObject={(v)=>{setCurrentQuestionObject(v)}}
     SetQuestionVisited={(v1,v2)=>{
  SetQuestionVisited(v1,v2)
 }}
    setLoadSections={(v)=>{setLoadSections(v)}}
    handleQuestionClick={(i)=>{handleQuestionClick(i)}}
       
       />



      
      <MockTestQuestion
      index ={currentQuestionIndex+1}
      mockTestCard1Object={mockTestCard1Object}
       currentQuestionObject={currentQuestionObject}
      SetQuestionAnswered={(v1,v2)=>{
        SetQuestionAnswered(v1,v2);
      }}
     showQuestionOptions={showQuestionOptions} 
      />

      
      
      </div>:
      <MockTestQuestionPaper
       setQuestionPaperVisible={(v)=>{setQuestionPaperVisible(v)}}


        responseArray={responseArray}
        currentSection={currentSection}
    
        sectionsArr={sectionsArr}
    currentSectionIndex={currentSectionIndex}
    
       sectionStatsAll={sectionStatsAll}
      
       mockTestCard1Object={mockTestCard1Object}
       setQuestionsArr={(v)=>{setQuestionsArr(v)}}
       questionsArrDummy={questionsArrDummy}
    setCurrentSection={(v)=>{setCurrentSection(v)}}
    setCurrentSectionIndex={(v)=>{setCurrentSectionIndex(v)}}
    setCurrentQuestionIndex={(v)=>{setCurrentQuestionIndex(v)}}
    setCurrentQuestionObject={(v)=>{setCurrentQuestionObject(v)}}
     SetQuestionVisited={(v1,v2)=>{
  SetQuestionVisited(v1,v2)
 }}
    setLoadSections={(v)=>{setLoadSections(v)}}
    handleQuestionClick={(i)=>{handleQuestionClick(i)}}
     
      />

}

      </div>
     
     
       <MockTestPalette 
       
       setQuestionPaperVisible={(v)=>{setQuestionPaperVisible(v)}}
      setPalletType={(v)=>{setPalletType(v)}}
       palletType={palletType}
       setPalletDirectionTemp={(v)=>{setPalletDirectionTemp(v)}}
     
       currentSection={currentSection}
       testDesignValue={testDesignValue}
       palletDirection={palletDirection}
       palletDirectionTemp={palletDirectionTemp}
       setPalletDirection={(v)=>{setPalletDirection(v)}}
        mockTestCard1Object={mockTestCard1Object}
 currentSectionIndex={currentSectionIndex}
 sectionsArr={sectionsArr}
 questionsArr={questionsArr}

 setButtonQuestionObject={(v1,v2)=>{
  setButtonQuestionObject(v1,v2)
 }}
 setCurrentQuestionObject={(v)=>setCurrentQuestionObject(v)}
 SetQuestionVisited={(v1,v2)=>{
  SetQuestionVisited(v1,v2)
 }}setCurrentQuestionIndex={(i)=>{setCurrentQuestionIndex(i)}}
 handleQuestionClick={(i)=>{handleQuestionClick(i)}}
 

       />
   

      
      </div>
      
      
       </div>
    
 <MockTestPagenation
 mockTestCard1Object={mockTestCard1Object}
 currentSectionIndex={currentSectionIndex}
 sectionsArr={sectionsArr}
 questionsArr={questionsArr}
 pagenationDirection={pagenationDirection}
 testDesignValue={testDesignValue}
 setButtonQuestionObject={(v1,v2)=>{
  setButtonQuestionObject(v1,v2)
 }}
 setCurrentQuestionObject={(v)=>setCurrentQuestionObject(v)}
 SetQuestionVisited={(v1,v2)=>{
  SetQuestionVisited(v1,v2)
 }}setCurrentQuestionIndex={(i)=>{setCurrentQuestionIndex(i)}}
 handleQuestionClick={(i)=>{handleQuestionClick(i)}}
 
 />
 
<MockTestBottom 
setCloseSubmitInfoPopUp={(v)=>{setCloseSubmitInfoPopUp(v)}}
setCloseHintPopUp={(v)=>{setCloseHintPopUp(v)}}
currentQuestionObject={currentQuestionObject}

mockTestCard1Object={mockTestCard1Object}
SetQuestionMarked={(v1,v2)=>{SetQuestionMarked(v1,v2)}} 
SetQuestionClearResponse={(v1,v2)=>{SetQuestionClearResponse(v1,v2)}} 
goTONextQuestion={()=>{goTONextQuestion()}} 
goTOPreviousQuestion={()=>{goTOPreviousQuestion()}}
/>

 {openCalculator?  <ScientificCalculator onClose={()=>{setOpenCalculator(false)}} /> :""}
    
      
        </div>
     <MockTestStyles mockTestCard1Object={mockTestCard1Object} />

</>)
}
export default MockTest;